export const fetchCountriesFromBackend = async () => {
  const cacheKey = "countries";
  const cacheExpiryKey = "countriesExpiry";
  const now = new Date().getTime();
  const cachedCountries = localStorage.getItem(cacheKey);
  const cacheExpiry = localStorage.getItem(cacheExpiryKey);

  if (cachedCountries && cacheExpiry && now < parseInt(cacheExpiry)) {
    return JSON.parse(cachedCountries);
  }

  return new Promise((resolve, reject) => {
    frappe.call({
      method: "frappe_stripe_subscription.api.utils.get_countries_list",
      callback: function (response) {
        if (response.message) {
          const countries = response.message;

          // Cache the data with an expiry (e.g., 1 day)
          const expiry = now + 96 * 60 * 60 * 1000; // 3 days in milliseconds
          localStorage.setItem(cacheKey, JSON.stringify(countries));
          localStorage.setItem(cacheExpiryKey, expiry.toString());

          resolve(countries);
        } else {
          reject("No countries returned from the server.");
        }
      },
      error: function (error) {
        console.error("Error fetching countries:", error);
        reject(error);
      },
    });
  });
};

export function removeDialogs() {
  let dialogs = document.getElementsByClassName("modal-body");
  let dialogsFade = document.getElementsByClassName("modal fade");
  if (dialogs.length > 0) {
    for (let i = 0; i < dialogs.length; i++) {
      dialogs[i].remove();
      dialogsFade[i].remove();
    }
  }
}

export async function getStripePublishableKey() {
  let publishableKey;
  await frappe.call({
    async: false,
    method: "frappe_stripe_subscription.api.utils.get_stripe_publishable_key",
    callback: function (response) {
      publishableKey = response.message;
    },
  });
  return publishableKey;
}
